<template>
    <div id="propertyList">
        <div class="search">
            <div class="searchbar">
                <i class="iconfont iconSearch left"></i>
                <form action="javascript:return true;">
                    <input v-model="listQuery.propertyInfo" placeholder="姓名/手机" type="search" @keypress="searchBtn" maxlength="11" />
                </form>
                <i v-if="listQuery.propertyInfo" @click="resetQuery" class="iconfont iconclose right"></i>
            </div>
        </div>
        <van-list v-model="loading" :finished="finished" :immediate-check="false" finished-text="没有更多了" @load="getList">
            <div class="body">
                <div class="card" v-for="(item,index) in list" :key="index" @click="$router.push({path:'/propertyDetail',query:{id:item.id}})">
                    <p>
                        <span>{{item.name}}&emsp;{{item.gender=="1"?"男":item.gender=="0"?"女":""}}</span>
                    </p>
                    <p>
                        <span>{{item.createDate}}</span>
                        <span class="phone">
                            <a :href="'tel:'+item.phone"  onclick="window.event.cancelBubble=true">
                                <i class="iconfont iconweibiaoti-"></i>
                            </a>
                            <!-- {{item.phone}} -->
                        </span>
                    </p>
                    <p v-if="item.remark">{{item.remark}}</p>
                </div>
            </div>
        </van-list>
        <div style="height:1.2rem"></div>
        <div class="btn">
            <van-button class="font1" v-if="$store.state.buttonAuth.indexOf('crm_propertyAdd')>-1" type="primary" block @click="$router.push({path:'propertyAdd'})">新增</van-button>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { requestPropertyList } from "@/api";
import { accSub } from "@/utils";
export default {
    name: "propertyList",
    data() {
        return {
            loading: false,
            finished: false,
            listQuery: {
                propertyInfo: "",
                pageSize: 10,
                pageNumber: 1,
            },
            list: [],
        };
    },
    computed: {
        ...mapState(["contractList"]),
    },
    activated() {
        this.finished = false;
        this.listQuery.pageNumber = 1;
        this.list = [];
        this.getList();
    },
    created() {},
    mounted() {},
    methods: {
        getList() {
            this.loading = true;
            const toast1 = this.$toast.loading({
                forbidClick: true,
                duration: 0,
                message: "加载中...",
            });
            requestPropertyList(this.listQuery)
                .then((res) => {
                    toast1.clear();
                    if (this.finished) return;
                    this.list = [...this.list, ...res.data.records];
                    let prePage = accSub(res.data.pages, 1);
                    this.loading = false;
                    this.listQuery.pageNumber++;
                    if (
                        (res.data.pages == res.data.current &&
                            res.data.records.length ==
                                accSub(res.data.total, prePage * 10)) ||
                        !res.data.records.length
                    ) {
                        this.finished = true;
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.finished = true;
                    toast1.clear();
                });
        },
        //点击搜索
        searchBtn() {
            this.listQuery.pageNumber = 1;
            this.list = [];
            this.finished = false;
            if (event.keyCode == 13) {
                event.preventDefault(); //禁止默认事件（默认是换行）
                if (
                    this.listQuery.propertyInfo == "" ||
                    this.listQuery.propertyInfo == null
                ) {
                    return;
                } else {
                    this.getList();
                }
            }
        },
        resetQuery() {
            this.listQuery.propertyInfo = "";
            this.list = [];
            this.listQuery.pageNumber = 1;
            this.finished = false;
            this.getList();
        },
    },
    watch: {},
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";
.body {
    // padding-top: 0.001rem;
    font-size: 0.35rem;
    .card {
        background: #fff;
        margin: 0.3rem;
        border-radius: 0.2rem;
        // margin: 0.2rem 0;
        p {
            display: flex;
            justify-content: space-between;
            padding: 0 0.4rem;
            line-height: 1rem;
            min-height: 1rem;
            text-align: left;
            .iconfont {
                color: $theme-color;
            }
            .go {
                color: $theme-color;
            }
        }
    }
    > .card:first-child {
        margin-top: 0;
    }
}
.search {
    padding: 0.3rem;
    display: flex;
    .status {
        width: 2rem;
        padding: 0.2rem 0;
        // span {
        //   display: inline-block;
        //   width: 1.2rem;
        //   overflow: hidden;
        //   text-overflow: ellipsis;
        //   vertical-align: text-bottom;
        //   white-space: nowrap;
        // }
        .iconxiala {
            font-size: 0.2rem;
        }
    }
    .searchbar {
        flex: 1;
        padding: 0.2rem;
        background-color: #fff;
        border-radius: 0.3rem;
        position: relative;
        .left {
            position: absolute;
            left: 0.3rem;
            top: 50%;
            transform: translateY(-50%);
        }
        .right {
            position: absolute;
            right: 0.3rem;
            top: 50%;
            transform: translateY(-50%);
        }
        input {
            background: none;
            outline: none;
            border: none;
            width: calc(100% - 1.5rem);
            text-align: center;
            height: 0.5rem;
            line-height: 0.5rem;
        }
    }
}
.btn {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: 0.1rem;
    overflow: hidden;
    display: flex;
    /deep/.van-button {
        margin-left: -1px;
        border: none;
        border-radius: 0;
        flex: 1;
        &:not(:last-child)::after {
            height: 50%;
            position: absolute;
            box-sizing: border-box;
            content: " ";
            pointer-events: none;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            border-right: 0.02667rem solid #ebedf0;
            z-index: 99;
        }
    }
    .font4 {
        width: 2.4rem;
    }
    .font3 {
        width: 1.8rem;
    }
    .font5 {
        width: 51%;
    }
    .font1 {
        width: 100%;
        margin-left: 0;
    }
}
</style>
